import React, { useState, useEffect } from 'react';
import s from './index.module.scss';
import locales from '../../../content.json';

export const Timer = ({ tariff }) => {
	const timerTime = 10; // minutes
	const initialTime = timerTime * 60;
	const [time, setTime] = useState(initialTime);

	useEffect(() => {
		const timer = setInterval(() => {
			if (time > 0) {
				setTime(time - 1);
			} else {
				clearInterval(timer);
			}
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, [time]);

	useEffect(() => {
		if (
				tariff === 'v5' 
				|| tariff === 'v7' 
				|| tariff === 'v9' 
				|| tariff === 'v11' 
				|| tariff === 'v13' 
				|| tariff === 'v15'
				|| tariff === 'v18'
				|| tariff === 'v20'
				|| tariff === 'v22'
				|| tariff === 'v24'
				|| tariff === 'v26'
				|| tariff === 'v28'
			) {
			setTime(initialTime);
		} 
	}, [tariff]);

	const minutes = sec => {
		const minutesValue = Math.floor(sec / 60);
		return `${String(minutesValue).padStart(2, '0')}`;
	};

	const seconds = sec => {
		const secondsValue = sec % 60;
		return `${String(secondsValue).padStart(2, '0')}`;
	};

	return (
		<div className={s.timerWrapper}>
			<p className={s.timerText} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_3 }} />
			<div className={s.timerTime}>
				<div className={s.timerCell}>
					<div className={s.timerCellNumber}>{minutes(time)}</div>
				</div>
				<div className={s.timerCellDivider}>:</div>
				<div className={s.timerCell}>
					<div className={s.timerCellNumber}>{seconds(time)}</div>
				</div>
			</div>
		</div>
	);
};